<template>
  <div class="content">
    <div class="content-row" v-if="assets && assets.length > 0">
      <div v-if="programName === 'US CF' || programName === 'US Wgnr' || programName === 'US CED'" class="title">
        {{ $t('program-rules') }}
      </div>
      <a v-if="programName === 'US CF'" :href="getLink('Program Rules')" target="_blank" class="button">{{
        $t('download')
      }}</a>
      <a v-if="programName === 'US Wgnr'" :href="getLink('Program Rules')" target="_blank" class="button">{{
        $t('download')
      }}</a>
      <a v-if="programName === 'US CED'" :href="getLink('Program Rules')" target="_blank" class="button">{{
        $t('download')
      }}</a>
    </div>
    <div class="content-row">
      <div v-if="programName === 'US ALFA'" class="title">
        {{ $t('dealer-best-practices') }}
      </div>
      <a v-if="programName === 'US ALFA'" :href="getLink('Dealer Best Practices')" target="_blank" class="button">{{
        $t('download')
      }}</a>
    </div>
    <div class="content-row" v-if="programName !== 'US CF'">
      <div class="title" v-if="programName === 'US CF' || programName === 'US CED'">{{ $t('program-faq') }}</div>
      <a class="button" v-if="programName === 'US CF'" :href="getLink('Program FAQ')" target="_blank">{{
        $t('download')
      }}</a>
      <a class="button" v-if="programName === 'US CED'" :href="getLink('Program FAQ')" target="_blank">{{
        $t('download')
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProgramRules',
  components: {},
  data() {
    return {
      loader: this.$loading.show(),
      assets: [],
    };
  },
  methods: {
    getAssets() {
      const domain = this.programName;
      this.$store
        .dispatch('getAssets', {
          domain,
        })
        .then((res) => {
          this.assets = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    getLink(title) {
      if (this.assets.length > 0) {
        const asset = this.assets.find((item) => item.assetTitle === title);
        return asset.url;
      }
      return null;
    },
  },
  computed: {
    ...mapState('global', ['programName']),
  },
  created() {
    this.getAssets();
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 40px;
  color: #000000;
  text-align: left;
  div {
    padding-top: 15px;
  }
  .link {
    color: #243882;
  }
}
.title {
  color: #243882;
  font-size: 24px;
  text-transform: uppercase;
  margin-bottom: 15px;
}
.button {
  font-size: 14px;
  margin-top: 30px;
  width: 120px;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  color: #fff;
  background-color: $primary;
  padding: 8px 20px;
  border-radius: 18px;
  transition: all 0.2s ease;
  &:hover {
    background-color: $primary-button-hover;
  }
}
.faq {
  margin-top: 20px;
}
</style>
